export enum CaptchaType {
  COMMON = "COMMON",
  PHONE = "PHONE",
}
